/**
 * @module store/tbim vuex状态数据模块 
 */

import { getAutoCDMModel, getGanttTasks, taskUtils } from "@/ref/autocdm/utils.js";
import { extractMeshs } from "@/ref/autocdm/threejsUtils.js";
import { sortTasks } from "@/ref/custom.js";
import global from "@/utils/global.js";

/**
 *从autoCDM取到的构件数据，set到state上，并分析出meshMap，meshs并set到state上
 *
 * @param {state} state
 * @param {modelGroup} modelGroup
 */
function setModelGroup(state, modelGroup) {
    state.modelGroup = modelGroup;
    state.meshs = [];
    state.meshsMap = {};
    if (modelGroup) {
        extractMeshs(modelGroup, state.meshs, state.compInfos);//从group抽出每个mesh并做一些处理，然后set到state.meshs上

        let a = state.meshs;
        for (let i = 0; i < a.length; i++) {//将每个mesh装到meshsMap上
            let key = a[i][global.meshKey];
            state.meshsMap[key] = a[i];
        }
    }
};

/**
 *
 *刷新当前项目下的【甘特图】任务数据。并set 到 state上
 * @param {state} state
 */
function refreshGanttTasks(state) {
    let promise1 = getGanttTasks(state.selectedProjectInfo.id);
    promise1.then(function (ganttTasks) {
        sortTasks(ganttTasks, null, function (taska, taskb) {
            taskUtils.fromServer(taska); taskUtils.fromServer(taskb);
        });
        if (ganttTasks.length == 1) {
            taskUtils.fromServer(ganttTasks[0]);
        }
        state.ganttTasks.data = ganttTasks;
    });
}
//--------------------------------------------------------------------
/**
 *  @type {store}
 *  @description vuex的store组件，存状态数据的容器。相关于具有状态监听功能的全局变量。
/** @type {*} */
let store = {
    state: {
        loadingStart: false,//选定项目后，初始化项目数据时，展示的loading标志


        selectedProjectInfo: {},
        //选中Mesh的颜色
        meshSelColor: new THREE.Color(0, 1, 0),
        //model数据-------
        modelGroup: null,
        meshs: [],
        compInfos: {},//每个mid对应自己的属性信息数据
        meshsMap: {},
        //-------------
        //modelView页面
        viewer: null,
        //模拟建造中，对比页面的viewer
        viewerPlaned: null,
        viewerActual: null,
        //当前用户下所有项目
        projectInfos: [],
        //甘特图数据
        ganttTasks: {
            data: [

            ],
            links: [

            ]
        },
        currentDatee: new Date(),
        //横道图日期格式
        switchDateLabel: 0,
        //虚拟建造速度
        playSpeed: 4,
        //是否全屏状态
        isFullScreen: false,
        isShowProjList: true
    },
    getters: {

    },
    mutations: {
        //当选择了项目的同时，也一起初始化项目的模型数据
        setSelectedProjectInfo(state, selectedProjectInfo) {
            state.loadingStart = true;

            state.selectedProjectInfo = selectedProjectInfo;
            //取模型数据
            let promise = getAutoCDMModel(selectedProjectInfo.id, selectedProjectInfo.projecttype);
            promise.then(function (obj) {
                let compInfos = obj.compInfos;
                state.compInfos = compInfos;
                //
                let g = obj.model;
                setModelGroup(state, g);

                //load
                setTimeout(function () {
                    state.loadingStart = false;
                    state.isShowProjList = false;
                }, 500);
            }).catch(function (e) {
                alert(e.message);
                console.log(e);
                state.loadingStart = false;
                state.isShowProjList = false;
            });
            //取tasks数据
            refreshGanttTasks(state);
            // let promise1 = getGanttTasks(selectedProjectInfo.id);
            // promise1.then(function (ganttTasks) {
            //     ganttTasks.forEach(function (task) {
            //         taskUtils.fromServer(task);
            //     });
            //     state.ganttTasks.data = ganttTasks;
            // });
        },
        setViewer(state, viewer) {
            state.viewer = viewer;
        },
        setViewerPlaned(state, viewer) {
            state.viewerPlaned = viewer;
        },
        setViewerActual(state, viewer) {
            state.viewerActual = viewer;
        },
        setProjectInfos(state, projectInfos) {
            state.projectInfos = projectInfos;
        },
        setModelGroup(state, modelGroup) {
            setModelGroup(state, modelGroup);
        },
        setGanttTasks(state, ganttTasks) {
            state.ganttTasks = ganttTasks;
        },
        refreshGanttTasks(state) {
            refreshGanttTasks(state);
        },
        setCurrentDatee(state, currentDatee) {
            state.currentDatee = currentDatee;
        },
        setLoadingStart(state, b) {
            state.loadingStart = b;
        },
        setSwitchDateLabel(state, switchDateLabel) {
            state.switchDateLabel = switchDateLabel;
        },
        setPlaySpeed(state, playSpeed) {
            state.playSpeed = playSpeed;
        },
        setFullScreen(state, isFullScreen) {
            state.isFullScreen = isFullScreen;
        },
        setShowProjList(state, isShowProjList) {
            state.isShowProjList = isShowProjList;
        }
    },
    actions: {

    }
};
export default store;


// WEBPACK FOOTER //
// ./src/store/modules/Tbim/tbim.js